import { render, staticRenderFns } from "./verifyPhone.vue?vue&type=template&id=c87a63b2&scoped=true&"
import script from "./verifyPhone.vue?vue&type=script&lang=js&"
export * from "./verifyPhone.vue?vue&type=script&lang=js&"
import style0 from "./verifyPhone.vue?vue&type=style&index=0&id=c87a63b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87a63b2",
  null
  
)

export default component.exports